"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.LocationDisplay = void 0;
var _react = _interopRequireDefault(require("react"));
var _accLocationsComponents = require("@adsk/acc-locations-components");
var _locationsHooks = require("../../utils/hooks/locationsHooks");
var _InlineValueDisplay = require("../../utils/components/InlineValueDisplay");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
const LocationDisplay = _ref => {
  let {
    locationId
  } = _ref;
  const {
    isLoading
  } = (0, _accLocationsComponents.useLocations)();
  const isLocationInTree = (0, _locationsHooks.useIsLocationInTree)();
  return /*#__PURE__*/_react.default.createElement(_InlineValueDisplay.InlineValueDisplay, {
    loading: isLoading,
    empty: !isLocationInTree(locationId)
  }, /*#__PURE__*/_react.default.createElement(_accLocationsComponents.LocationNameDisplay, {
    locationNodeId: locationId
  }));
};
exports.LocationDisplay = LocationDisplay;
//# sourceMappingURL=LocationDisplay.js.map